import React,{useMemo, useState} from "react";
import {IconButton,TextField,Button,Box,Typography,Tab,Tabs,Paper,Grid,Checkbox,FormControlLabel,InputLabel,Select,OutlinedInput,MenuItem,FormControl,Alert,Dialog,DialogActions,DialogContent,DialogContentText, DialogTitle   } from '@mui/material'
import { CButton } from "@coreui/react";
import Dropzone from 'react-dropzone';
import DropzoneComponent from 'react-dropzone-component';
import {useDropzone} from 'react-dropzone';
import unsplash from "../api/unsplash";
import Upload from '@mui/icons-material/Upload';

const FileUploader =  () =>{
    const [open, setOpen] =useState(false);
    const {acceptedFiles,isDragAccept,isDragReject,isFocused, getRootProps, getInputProps} = useDropzone();
    const [files,setFiles] = useState([]);

    const baseStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out'
      };
      
      const focusedStyle = {
        borderColor: '#2196f3'
      };
      
      const acceptStyle = {
        borderColor: '#00e676'
      };
      
      const rejectStyle = {
        borderColor: '#ff1744'
      };  

const handleUpload =async () => {
    
if(files.length === 0){
    alert("Nessun file selezionato")
}else{

    const formData = new FormData();
    formData.append("colonna","Cliente");
    formData.append("ID",260);
    files.map(file => { formData.append("file", file);})
    try{
    await unsplash.post('caricaDoc',formData, {headers: {
    'content-type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem("jwt")}`}}).then( res=> {alert("ok")})
    }catch{alert("errore");}
}

}

const handleClose = () => {
    
        setOpen(false);
      };
const onDrop = (acceptedFiles) => {

 setFiles(acceptedFiles)
 console.log(acceptedFiles)
}
      
  
  

      const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
      }), [
        isFocused,
        isDragAccept,
        isDragReject
      ]);

return(
    <>
<IconButton onClick={()=>{setOpen(true);setFiles([])}}><Upload 
  style={{height:"2rem",width:"2rem",color:"#2264ae"}}
 
    />
</IconButton>
    <Dialog open={open} onClose={handleClose}>
    <DialogTitle>Carica File</DialogTitle>
    <DialogContent>
    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}>
  {({getRootProps, getInputProps}) => (
    <div {...getRootProps({style})}>
      <input {...getInputProps()} />
      <p>Trascina e rilascia qui o fai clic per selezionare i file</p>
      
    </div>
    
  )}
 
</Dropzone>
<aside>
<h4>Files</h4>
    {files?.map(file => {
        return(
<>

        <ul>{file.path}</ul>
</>)

    })
        
    }
      </aside>
        </DialogContent>
        <DialogActions>
        <CButton onClick={handleUpload}>Carica</CButton>
        <CButton  onClick={handleClose}>Annulla</CButton>
        
        </DialogActions>
        </Dialog>

        </>
)


}

export default FileUploader